var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "box view-nav-bar" }, [
      _c(
        "div",
        { staticClass: "d-flex align-items-center w-100" },
        [
          _c(
            "div",
            { staticClass: "flex-grow-1" },
            [
              _c(
                "router-link",
                {
                  staticClass: "mr-3",
                  attrs: { to: "/admissions/year/" + _vm.year },
                },
                [
                  _c("icon", { attrs: { name: "chevron-left" } }),
                  _vm._v(" Back\n                "),
                ],
                1
              ),
              _vm._v(" "),
              _c("strong", [_vm._v(_vm._s(_vm.weekCode))]),
              _vm._v(" "),
              _c("span", { staticClass: "text-muted ml-2" }, [
                _vm._v("— Admissions per cinema"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("b-form-select", {
            staticClass: "transparent-input shx-th-120",
            attrs: { options: _vm.saleshouseOptions },
            on: { change: _vm.loadSites },
            model: {
              value: _vm.saleshouse,
              callback: function ($$v) {
                _vm.saleshouse = $$v
              },
              expression: "saleshouse",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _vm.loading
      ? _c("div", { staticClass: "box" }, [
          _c(
            "div",
            { staticClass: "box-content text-center text-muted py-4" },
            [_vm._v("Loading…")]
          ),
        ])
      : !_vm.rows.length
      ? _c("div", { staticClass: "box" }, [
          _c(
            "div",
            { staticClass: "box-content text-center text-muted py-4" },
            [
              _vm._v(
                "No admissions data found for " + _vm._s(_vm.weekCode) + "."
              ),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.loading && _vm.previousWeek
      ? _c("div", { staticClass: "box" }, [
          _c("div", { staticClass: "box-content" }, [
            !_vm.previousWeek.missing.length && !_vm.previousWeek.extra.length
              ? _c(
                  "div",
                  { staticClass: "text-muted" },
                  [
                    _c("icon", { attrs: { name: "check" } }),
                    _vm._v(
                      " Same " +
                        _vm._s(_vm.rows.length) +
                        " cinemas as\n                "
                    ),
                    _c("router-link", { attrs: { to: _vm.previousWeekLink } }, [
                      _vm._v(_vm._s(_vm.previousWeek.week_code)),
                    ]),
                    _vm._v(".\n            "),
                  ],
                  1
                )
              : _c("div", [
                  _c(
                    "div",
                    { staticClass: "mb-1" },
                    [
                      _vm._v(
                        "\n                    Compared to\n                    "
                      ),
                      _c(
                        "router-link",
                        { attrs: { to: _vm.previousWeekLink } },
                        [_vm._v(_vm._s(_vm.previousWeek.week_code))]
                      ),
                      _vm._v(
                        "\n                    (" +
                          _vm._s(_vm.previousWeek.cinemas) +
                          " cinemas → " +
                          _vm._s(_vm.rows.length) +
                          " cinemas):\n                "
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.previousWeek.missing.length
                    ? _c(
                        "div",
                        { staticClass: "alert alert-danger mb-2 py-2" },
                        [
                          _c("strong", [
                            _vm._v(
                              "⚠ Missing " +
                                _vm._s(_vm.previousWeek.missing.length) +
                                "\n                        " +
                                _vm._s(
                                  _vm.previousWeek.missing.length === 1
                                    ? "cinema"
                                    : "cinemas"
                                )
                            ),
                          ]),
                          _vm._v(
                            "\n                    (reported in " +
                              _vm._s(_vm.previousWeek.week_code) +
                              ", no data in " +
                              _vm._s(_vm.weekCode) +
                              "):\n                    "
                          ),
                          _c(
                            "ul",
                            { staticClass: "mb-0 mt-1" },
                            _vm._l(_vm.previousWeek.missing, function (c) {
                              return _c(
                                "li",
                                { key: "missing-" + c.theatre_code },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(c.theatre_code)),
                                  ]),
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(c.theatre_name || "—")
                                  ),
                                  c.city
                                    ? _c("span", [
                                        _vm._v(", " + _vm._s(c.city)),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "text-muted" }, [
                                    _vm._v(
                                      "— " +
                                        _vm._s(_vm.formatInt(c.admissions)) +
                                        " admissions in " +
                                        _vm._s(_vm.previousWeek.week_code)
                                    ),
                                  ]),
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "mt-2 small" }, [
                            _vm._v(
                              "\n                        Double-check by verifying in\n                        "
                            ),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: "https://bitbucket.org/brightfishbe/cinedata_raw/",
                                  target: "_blank",
                                  rel: "noopener",
                                },
                              },
                              [_vm._v("cinedata_raw")]
                            ),
                            _vm._v(
                              "\n                        whether Cinedata delivered files for these cinemas between\n                        "
                            ),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.bucket.week_start || "?")),
                            ]),
                            _vm._v(" and "),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.bucket.week_end || "?")),
                            ]),
                            _vm._v(
                              "\n                        (" +
                                _vm._s(_vm.weekCode) +
                                ").\n                    "
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.previousWeek.extra.length
                    ? _c("div", { staticClass: "alert alert-info mb-0 py-2" }, [
                        _c("strong", [
                          _vm._v(
                            "+ " +
                              _vm._s(_vm.previousWeek.extra.length) +
                              " new\n                        " +
                              _vm._s(
                                _vm.previousWeek.extra.length === 1
                                  ? "cinema"
                                  : "cinemas"
                              )
                          ),
                        ]),
                        _vm._v(
                          "\n                    (not reported in " +
                            _vm._s(_vm.previousWeek.week_code) +
                            "):\n                    "
                        ),
                        _c(
                          "ul",
                          { staticClass: "mb-0 mt-1" },
                          _vm._l(_vm.previousWeek.extra, function (c) {
                            return _c(
                              "li",
                              { key: "extra-" + c.theatre_code },
                              [
                                _c("strong", [_vm._v(_vm._s(c.theatre_code))]),
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(c.theatre_name || "—")
                                ),
                                c.city
                                  ? _c("span", [_vm._v(", " + _vm._s(c.city))])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", { staticClass: "text-muted" }, [
                                  _vm._v(
                                    "— " +
                                      _vm._s(_vm.formatInt(c.admissions)) +
                                      " admissions"
                                  ),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                      ])
                    : _vm._e(),
                ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.loading && _vm.rows.length
      ? _c("div", { staticClass: "box" }, [
          _c("div", { staticClass: "box-content" }, [
            _c("table", { staticClass: "shx-table w-100 mt-2" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.rows, function (row) {
                  return _c("tr", { key: row.theatre_code }, [
                    _c("td", [_vm._v(_vm._s(row.theatre_code))]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n                            " +
                          _vm._s(row.theatre_name || "—") +
                          "\n                            "
                      ),
                      _vm.newCinemas[row.theatre_code]
                        ? _c(
                            "span",
                            {
                              staticClass: "badge badge-info ml-1",
                              attrs: {
                                title:
                                  "Not reported in " +
                                  _vm.previousWeek.week_code,
                              },
                            },
                            [_vm._v("new")]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(row.city || "—"))]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-right" }, [
                      _vm._v(_vm._s(_vm.formatInt(row.admissions))),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-right" }, [
                      _vm._v(_vm._s(row.titles)),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-right" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            row.real_weighted != null
                              ? row.real_weighted + "%"
                              : "—"
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      row.real_weighted != null && row.real_weighted <= 90
                        ? _c(
                            "span",
                            {
                              staticClass: "badge badge-warning ml-1",
                              attrs: {
                                title: "Minimum real: " + row.real_min + "%",
                              },
                            },
                            [_vm._v("⚠")]
                          )
                        : _vm._e(),
                    ]),
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _c("tfoot", [
                _c("tr", [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-right" }, [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.formatInt(_vm.totalAdmissions))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", { attrs: { colspan: "2" } }),
                ]),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "shx-th-80" }, [_vm._v("Code")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cinema")]),
        _vm._v(" "),
        _c("th", { staticClass: "shx-th-140" }, [_vm._v("City")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right" }, [_vm._v("Admissions")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [
          _vm._v("# Titles"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [_vm._v("Real %")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { attrs: { colspan: "3" } }, [
      _c("strong", [_vm._v("Total")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }